import React, { FC } from 'react'
import { Box, Link } from '@ally/metronome-ui'
import styled from 'styled-components'
import { AdobeTileContent } from '../../types'
import MdSmTileGroup from './MdSmTileGroup'

const StyledLink = styled(Link)`
  white-space: normal;
  text-align: center;
`

const MdSmExploreTiles: FC<{ exploreTiles: AdobeTileContent }> = React.memo(
  ({ exploreTiles }) => {
    return exploreTiles ? (
      <Box padding="sm">
        <Box textAlign="center" mb="sm">
          <StyledLink
            text="Innovative options make reaching your goals possible."
            to="/products-and-rates"
          />
        </Box>
        <MdSmTileGroup data={exploreTiles} />
      </Box>
    ) : null
  },
)

export default MdSmExploreTiles
